<template>
  <div>
    <div class="full-container trial_search">
      <div class="main-container t_search">
        <h1>{{ $t("tool.track.title") }}</h1>
        <el-input
          placeholder="Please enter: airline master air waybill number such as 99952852133"
          class="j-footer-search-input"
          v-model="query"
          maxlength="12"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            :loading="loading"
            @click="searchHandler"
            type="primary"
          >
          </el-button>
        </el-input>
      </div>
    </div>
    <div class="full-container trial_contents">
      <div class="main-container trial_cont">
        <div class="t_box t_box1">
          <div class="waybill_number">
            <h1>
              {{ $t("tool.track.waybillNum") }}<span>{{ awb }}</span>
            </h1>
          </div>
          <h1>{{ $t("tool.track.basicInfo") }}</h1>
          <div
            class="base-info"
            v-for="(item, index) in basedata"
            :key="'basedata-' + index"
            v-if="hidden == true"
          >
            <div class="yc_route yc_flex">
              <div class="yc_flex">
                <p>{{ item.DEPPORT != "" ? item.DEPPORT : "" }}</p>
                <span>{{ item.FLIGHTNO1 != "" ? item.FLIGHTNO1 : "" }}</span>
                <p v-if="item.MIDPORT1 != ''">{{ item.MIDPORT1 }}</p>
                <span v-if="item.MIDPORT1 != ''">{{ item.FLIGHTNO2 }}</span>
                <p v-if="item.MIDPORT2 != ''">{{ item.MIDPORT2 }}</p>
                <span v-if="item.MIDPORT2 != ''">{{ item.FLIGHTNO3 }}</span>
                <p v-if="item.MIDPORT3 != ''">{{ item.MIDPORT3 }}</p>
                <span v-if="item.MIDPORT3 != ''">{{ item.FLIGHTNO4 }}</span>
                <p>{{ item.ARRPORT != "" ? item.ARRPORT : "" }}</p>
              </div>
            </div>
            <div class="yc_distance yc_flex">
              <b v-if="item.MIDPORT1 == ''"
                >{{ $t("home.departure") }} <i class="yc_lines"></i
                ><i class="y_lin"></i
              ></b>
              <b v-if="item.MIDPORT1 != '' && item.MIDPORT2 == ''"
                >{{ $t("home.departure") }} <i class="z_circle"></i
                ><i class="y_line"></i
              ></b>
              <b v-if="item.MIDPORT2 != '' && item.MIDPORT3 == ''"
                >{{ $t("home.departure") }} <i class="z_circle2"></i
                ><i class="z_line2"></i
              ></b>
              <b v-if="item.MIDPORT3 != ''"
                >{{ $t("home.departure") }} <i class="z_circle3"></i
                ><i class="z_line3"></i
              ></b>
              <span>
                {{ item.PIECE != "" ? item.PIECE : "0"
                }}{{ $t("tool.track.pieces") }}
                {{ item.WEIGHT != "" ? item.WEIGHT : "0" }}KG
              </span>
              <b v-if="item.MIDPORT1 != '' && item.MIDPORT2 == ''"
                >{{ $t("tool.track.transit") }}<i class="z_circle"></i
                ><i class="y_line"></i
              ></b>
              <b v-if="item.MIDPORT2 != '' && item.MIDPORT3 == ''"
                >{{ $t("tool.track.transit") }}<i class="z_circle2"></i
                ><i class="z_line2"></i
              ></b>
              <span v-if="item.MIDPORT1 != ''">
                {{ item.PIECE != "" ? item.PIECE : "0"
                }}{{ $t("tool.track.pieces") }}
                {{ item.WEIGHT != "" ? item.WEIGHT : "0" }}KG
              </span>
              <b v-if="item.MIDPORT2 != '' && item.MIDPORT3 == ''"
                >{{ $t("tool.track.transit") }}<i class="z_circle2"></i
                ><i class="z_line2"></i
              ></b>
              <span v-if="item.MIDPORT2 != ''">
                {{ item.PIECE != "" ? item.PIECE : "0"
                }}{{ $t("tool.track.pieces") }}
                {{ item.WEIGHT != "" ? item.WEIGHT : "0" }}KG
              </span>
              <b v-if="item.MIDPORT3 != ''"
                >{{ $t("tool.track.transit") }}<i class="z_circle3"></i
                ><i class="z_line3"></i
              ></b>
              <span v-if="item.MIDPORT3 != ''">
                {{ item.PIECE != "" ? item.PIECE : "0"
                }}{{ $t("tool.track.pieces") }}
                {{ item.WEIGHT != "" ? item.WEIGHT : "0" }}KG
              </span>
              <b v-if="item.MIDPORT1 == ''"
                >{{ $t("home.destination") }} <i class="yc_lines"></i
              ></b>
              <b v-if="item.MIDPORT1 != '' && item.MIDPORT2 == ''"
                >{{ $t("home.destination") }} <i class="z_circle"></i
              ></b>
              <b v-if="item.MIDPORT2 != '' && item.MIDPORT3 == ''"
                >{{ $t("home.destination") }} <i class="z_circle2"></i
              ></b>
              <b v-if="item.MIDPORT3 != ''"
                >{{ $t("home.destination") }} <i class="z_circle3"></i
              ></b>
            </div>
          </div>
          <div v-if="hidden == false" class="warring">
            <p>{{ $t("tool.track.noBasic") }}</p>
          </div>
          <h1>{{ $t("tool.track.trackInfo") }}</h1>
          <div
            class="typeE"
            name="出口"
            v-for="(item, index) in basedata"
            :key="'basedata-1-' + index"
            v-if="item.IETYPE == 'E' && hidden == true"
          >
            <div class="IETYPE">
              <img
                v-lazy="'//doc.yctop.com/v3/images/order/track_dc.png'"
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 1 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS >= 2
                    ? '//doc.yctop.com/v3/images/order/track_hg.png'
                    : '//doc.yctop.com/v3/images/order/track_hgh.png'
                "
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 2 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS >= 3
                    ? '//doc.yctop.com/v3/images/order/track_lg.png'
                    : '//doc.yctop.com/v3/images/order/track_lgh.png'
                "
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 3 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS >= 4
                    ? '//doc.yctop.com/v3/images/order/track_dep.png'
                    : '//doc.yctop.com/v3/images/order/track_deph.png'
                "
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 4 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS == 5
                    ? '//doc.yctop.com/v3/images/order/track_th.png'
                    : '//doc.yctop.com/v3/images/order/track_thh.png'
                "
                alt=""
              />
            </div>
            <div class="route_title IETYPE">
              <p :class="item.CURRENTSTATUS >= 1 ? 'blue' : 'gray'">
                {{ $t("query.book") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 2 ? 'blue' : 'gray'">
                {{ $t("tool.track.customs") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 3 ? 'blue' : 'gray'">
                {{ $t("tool.track.leave") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 4 ? 'blue' : 'gray'">
                {{ $t("home.destination") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 5 ? 'blue' : 'gray'">
                {{ $t("tool.track.Pickup") }}
              </p>
            </div>
            <div class="route_cont">
              <div>
                <p>
                  {{
                    item.CURRENTSTATUS >= 1 && item.BKDSTATUS == ""
                      ? "Airline booked space"
                      : item.BKDSTATUS
                  }}
                </p>
                <p v-if="item.CURRENTSTATUS > 1">
                  {{
                    item.CURRENTSTATUS > 2 && item.DECLARESTATUS == ""
                      ? "Customs has released"
                      : item.DECLARESTATUS
                  }}
                </p>
                <p v-if="item.CURRENTSTATUS > 2">{{ item.DEPSTATUS }}</p>
                <p v-if="item.CURRENTSTATUS > 3">
                  {{
                    item.ARRSTATUS == "" && item.ARRTIME != ""
                      ? "Goods arrive" + item.ARRPORT
                      : item.CURRENTSTATUS > 3 && item.ARRSTATUS == ""
                      ? "Goods arrive" + item.ARRPORT
                      : item.ARRSTATUS
                  }}
                </p>
                <p v-if="item.CURRENTSTATUS > 4">{{ item.DLVSTATUS }}</p>
              </div>
              <div>
                <p>{{ item.BKDTIME == "" ? "" : item.BKDTIME }}</p>
                <p>{{ item.DECLARETIME == "" ? "" : item.DECLARETIME }}</p>
                <p>{{ item.DEPTIME == "" ? "" : item.DEPTIME }}</p>
                <p>{{ item.ARRTIME == "" ? "" : item.ARRTIME }}</p>
                <p>{{ item.DLVTIME == "" ? "" : item.DLVTIME }}</p>
              </div>
            </div>
          </div>
          <div
            class="typeI"
            name="进口"
            v-for="(item, index) in basedata"
            :key="'basedata-2-' + item"
            v-if="item.IETYPE == 'I' && hidden == true"
          >
            <div class="IETYPE">
              <img
                v-lazy="'//doc.yctop.com/v3/images/order/track_lg.png'"
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 1 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS >= 2
                    ? '//doc.yctop.com/v3/images/order/track_bg.png'
                    : '//doc.yctop.com/v3/images/order/track_bgh.png'
                "
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 2 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS >= 3
                    ? '//doc.yctop.com/v3/images/order/track_dep.png'
                    : '//doc.yctop.com/v3/images/order/track_deph.png'
                "
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 3 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS >= 4
                    ? '//doc.yctop.com/v3/images/order/track_hg.png'
                    : '//doc.yctop.com/v3/images/order/track_hgh.png'
                "
                alt=""
              />
              <div
                :class="item.CURRENTSTATUS > 4 ? 'line_blue' : 'line_gray'"
              ></div>
              <img
                :src="
                  item.CURRENTSTATUS == 5
                    ? '//doc.yctop.com/v3/images/order/track_th.png'
                    : '//doc.yctop.com/v3/images/order/track_thh.png'
                "
                alt=""
              />
            </div>
            <div class="route_title IETYPE">
              <p :class="item.CURRENTSTATUS >= 1 ? 'blue' : 'gray'">
                {{ $t("tool.track.leave") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 2 ? 'blue' : 'gray'">
                {{ $t("tool.track.manifest") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 3 ? 'blue' : 'gray'">
                {{ $t("home.destination") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 4 ? 'blue' : 'gray'">
                {{ $t("tool.track.clearance") }}
              </p>
              <p :class="item.CURRENTSTATUS >= 5 ? 'blue' : 'gray'">
                {{ $t("tool.track.Pickup") }}
              </p>
            </div>
            <div class="route_cont">
              <div>
                <p>{{ item.DEPSTATUS }}</p>
                <p v-if="item.CURRENTSTATUS > 1">
                  {{
                    item.MFTORIGINSTATUS == "" && item.MFTORIGINTIME != ""
                      ? "The original manifest is transmitted successfully"
                      : item.CURRENTSTATUS > 2 && item.MFTORIGINSTATUS == ""
                      ? "The original manifest is transmitted successfully"
                      : item.MFTORIGINSTATUS
                  }}
                </p>
                <p v-if="item.CURRENTSTATUS > 2">
                  {{
                    item.ARRSTATUS == "" && item.ARRTIME != ""
                      ? "Goods arrive" + item.ARRPORT
                      : item.CURRENTSTATUS > 3 && item.ARRSTATUS == ""
                      ? "Goods arrive" + item.ARRPORT
                      : item.ARRSTATUS
                  }}
                </p>
                <p v-if="item.CURRENTSTATUS > 3">
                  {{
                    item.CURRENTSTATUS > 2 && item.DECLARESTATUS == ""
                      ? "Customs has released"
                      : item.DECLARESTATUS
                  }}
                </p>
                <p v-if="item.CURRENTSTATUS > 4">{{ item.DLVSTATUS }}</p>
              </div>
              <div>
                <p>{{ item.DEPTIME == "" ? "" : item.DEPTIME }}</p>
                <p>{{ item.MFTORIGINTIME == "" ? "" : item.MFTORIGINTIME }}</p>
                <p>{{ item.ARRTIME == "" ? "" : item.ARRTIME }}</p>
                <p>{{ item.DECLARETIME == "" ? "" : item.DECLARETIME }}</p>
                <p>{{ item.DLVTIME == "" ? "" : item.DLVTIME }}</p>
              </div>
            </div>
          </div>
          <div v-if="hidden == false" class="warring">
            <p>{{ $t("tool.track.noTrack") }}</p>
          </div>
        </div>
        <div class="t_box t_box2">
          <h3>{{ $t("tool.track.detail") }}</h3>
          <div class="ico"></div>
          <img
            v-lazy="
              '//doc.yctop.com/yc/static/images/yc-we-app-code.jpg'
            "
            alt=""
          />
          <p>{{ $t("tool.track.follow") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped="true">
@import "~@/assets/css/view/tool/trial.css";
</style>
<script type="babel">
import YC_REQUEST_HANDLER from "@/api/request.js";
import UTILS from '@/utils/utils';
export default {
  	data: function() {
  		return {
  			awb: '',
  			query: '',
			loading: false,
			basedata:[],
			detaildata:[],
			hidden: true,
  		}
  	},
  	mounted: function() {
		this.query=this.awb = this.$route.query.customscode
  		if (this.awb) {
  			this.loadData()
  		}
  	},
  	methods: {
  		loadData: function() {
			var _this=this
			_this.loading = true
			if(_this.awb.length==11){
				_this.awb=_this.awb.substring(0,3)+'-'+_this.awb.substring(3,11)
			}
			var params = {
				resource: 2,
				awb: _this.awb
            }
            var url='/api/uc/trail/awb/simple'
            var successCallBack = function(res) {
                var resData=res.trailResult;
					if (resData.resultData) {
                        var resultData=eval("("+resData.resultData+")");//转换为json对象
						for(var i=0;i<resultData.RESULTDATA.length;i++){
							var HAVEDATA = resultData.RESULTDATA[0].HAVEDATA;
							var STATUSCODE = resultData.RESULTDATA[0].STATUSCODE;
							var IETYPE = resultData.RESULTDATA[0].IETYPE;
							var CURRENTSTATUS=resultData.RESULTDATA[0].CURRENTSTATUS;
							if (HAVEDATA == 'false' && STATUSCODE == "1000" || HAVEDATA == 'true' && IETYPE == '') {
								_this.hidden = false;
								_this.loading = false;
							}else if (STATUSCODE == "9999" && HAVEDATA == 'false') {
								_this.hidden = false;
								_this.loading = false;
							}else if(CURRENTSTATUS==0){
								_this.hidden = false;
								_this.loading = false;
							}else {
									_this.hidden = true;
									_this.basedata = resultData.RESULTDATA;
									_this.loading = false;
							}
                        }
                    }
            }
            var failCallBack = function(errcode, errmessage) {
                _this.$bus.emit("common-error-handler", errmessage);
            };
            YC_REQUEST_HANDLER.postQuery(url, params, successCallBack, failCallBack);

		},
  		validAwb: function() {
  			let awb = this.awb,
				reg = new RegExp("^[0-9]{3}-{0,1}[0-9]{8}$")

			if (awb == '' || !reg.test(awb) || awb.length > 12 || awb.length < 11) {
                this.$notify.error({
		          	title: 'Error',
		          	message: 'Please enter the correct waybill number'
		        });
                return false
			}
            var subthree = awb.substr(0, 3);
            if (UTILS.Valod_AWB_Prefix_Array.indexOf(subthree) == '-1') {
                this.$notify.error({
		          	title: 'Error',
		          	message: 'This airline is not currently supported'
		        });
                return false;
            }
            return true
  		},
  		searchHandler: function() {
            this.awb=this.query
  			if (!this.validAwb()) {
  				return;
            }
  			this.loadData()
		  },

  	},
}
</script>
